import { render, staticRenderFns } from "./AddObligations.vue?vue&type=template&id=00dafbde"
import script from "./AddObligations.vue?vue&type=script&lang=js"
export * from "./AddObligations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports